import { render } from "./ControleDeFuncionalidade.vue?vue&type=template&id=d054a7b8"
import script from "./ControleDeFuncionalidade.vue?vue&type=script&lang=js"
export * from "./ControleDeFuncionalidade.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__